const liberBlack = {
    400: '#343A40',
    300: '#4D5158',
    200: '#7B7C83',
    100: '#AAA8AE',
};
export default liberBlack;
